import React from 'react';
import {GlobalFooterPagelet} from '@tkww/orion-web-global-pagelets';
import {TK_HOST} from '../../constants';

const ANALYTICS_PRODUCT_NAME = 'shopping';

const LEGAL_LINKS = [
  {text: 'Privacy Policy', url: 'https://www.theknotww.com/privacy-policy/'},
  {text: 'Terms of Use', url: 'https://www.theknotww.com/terms-of-use/'},
  {
    text: 'Accessibility',
    url: 'https://www.theknotww.com/accessibility-statement/',
  },
  {
    text: 'Do Not Sell My Info',
    url:
      'https://theknotww.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000590371',
  },
  {
    text: 'CA Privacy',
    url: 'https://www.theknotww.com/ca-collection-notice/',
  },
  {text: 'Customer Service', url: 'https://helpcenter.theknot.com/hc/en-us'},
  {
    text: 'Retail Terms',
    url: `${TK_HOST}/registry/store/static/retail-terms`,
  },
  {
    text: 'Product Recall',
    url: `${TK_HOST}/registry/store/static/product-recall-policy`,
  },
];

const Footer = () => {
  return (
    <GlobalFooterPagelet
      forwardProps={{analyticsProps: {product: ANALYTICS_PRODUCT_NAME}}}
      legalLinks={LEGAL_LINKS}
    />
  );
};

export default Footer;
